
import {Vue, Component} from 'vue-property-decorator';
import {GOOGLE_MAPS_KEY, nil} from '@/common';
@Component({
    components: {
    },
})
export default class BookingGoogleMapsMixin extends Vue {
    public booking!: any;
    public mapHeight!: number;
    public mapWidth!: number;
    get asGoogleStaticMap() {
        if (nil(this.booking)) { return ''; }
        const {location} = this.booking;
        if (nil(location) || location.coordinates.length !== 2) {
            return '';
        }
        // https://maps.googleapis.com/maps/api/staticmap?size=512x512&maptype=roadmap&markers=size:mid|color:red|San Francisco,CA|Oakland,CA|San Jose,CA&ke
        const markers = encodeURI(`markers=size:mid|color:red|${location.coordinates[1]},${location.coordinates[0]}`);
        return `https://maps.googleapis.com/maps/api/staticmap?center=${this.asGoogQuery}&size=${this.mapWidth}x${this.mapHeight}&maptype=roadmap&${markers}&key=${GOOGLE_MAPS_KEY}`;
    }
    public get asGoogleMapsLink() {
        if (nil(this.booking)) { return ''; }
        const {location, address} = this.booking;
        if (!nil(address)) {
            return `https://www.google.com/maps/search/?api=1&query=${encodeURI(address)}`;
        } else if (!nil(location)) {
            return `https://maps.google.com/?ll=${location.coordinates[1]},${location.coordinates[0]}`;
        }
        return '#';
    }

    public get asGoogQuery() {
        if (nil(this.booking)) { return ''; }
        const {location, address} = this.booking;
        if (!nil(address)) {
            return encodeURI(address);
        } else if (!nil(location)) {
            return `${location.coordinates[1]},${location.coordinates[0]}`;
        }
        return '';
    }
}
